import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";

export function Field({ label, children, className = "" }) {
  return <div className={className}><Label className="text-xs text-slate-500">{label}</Label><div className="mt-1">{children}</div></div>;
}

export function NSelect({ value, onChange, options, placeholder = "—", testid, ...rest }) {
  return (
    <select value={value || ""} onChange={(e) => onChange(e.target.value)} data-testid={testid} {...rest}
      className="h-9 w-full rounded-md border border-input bg-white px-2 text-sm focus:outline-none focus:ring-2 focus:ring-brand-500">
      <option value="">{placeholder}</option>
      {options.map((o) => typeof o === "string" ? <option key={o} value={o}>{o}</option> : <option key={o.value} value={o.value}>{o.label}</option>)}
    </select>
  );
}

export function TInput({ value, onChange, testid, ...rest }) {
  return <Input value={value ?? ""} onChange={(e) => onChange(e.target.value)} data-testid={testid} {...rest} />;
}
